<template>
    <div class="kfc_checkout_wrap">
        <div v-if="!isWaiSong" class="diner_info fc">
            <span
                >餐厅名称：{{ selectedDiner.name }} -
                {{ selectedDiner.cityname }}</span
            >
            <span>餐厅地址：{{ selectedDiner.address }}</span>
        </div>
        <div v-show="isWaiSong" class="delivery_info fc">
            <h3>配送地址</h3>
            <div
                v-if="addressList && addressList.length != 0 && selectedAddress"
                class="info fr ac"
                @click="toAddressList"
            >
                <img
                    class="location_icon"
                    src="../../../static/imgs/kfc/location_kfc.png"
                    alt
                />
                <div class="fc">
                    <p class="receiver_info">
                        <span class="receiver">{{
                            selectedAddress.realname
                        }}</span>
                        <span class="phone">{{ selectedAddress.mobile }}</span>
                    </p>
                    <p class="address">
                        {{ selectedAddress.provincename }}
                        {{ selectedAddress.cityname }}
                        {{ selectedAddress.countyname }}
                        {{ selectedAddress.address }}
                    </p>
                </div>
            </div>
            <div
                v-if="!addressList || addressList.length == 0"
                class="info fr ac jsb"
                @click="addAddress"
            >
                <div class="fr ac">
                    <img
                        class="location_icon"
                        src="../../../static/imgs/kfc/location_kfc.png"
                        alt
                    />
                    <span class="add_address">请填写配送地址</span>
                </div>
                <img
                    src="../../../static/imgs/kfc/right.png"
                    class="right_icon"
                    alt
                />
            </div>
        </div>
        <div class="order_detail fc">
            <h3>餐品详情</h3>
            <div
                class="order_item_wrap fc"
                v-for="(item, index) in cartArr"
                :key="index"
            >
                <div class="order_item fr ac jsb">
                    <div class="fr ac">
                        <img :src="imgBaseUrl + item.logo" alt="" />
                        <h4>{{ item.name }}</h4>
                        <span @click="toggleDetail(index)" class="toggle">{{
                            item.isExtend ? "收起" : "详情"
                        }}</span>
                    </div>
                    <div class="fr ac">
                        <span>￥{{ item.actualPrice }}</span>
                        <span class="qty">×{{ item.qty }}</span>
                    </div>
                </div>
                <p
                    class="item_desp"
                    v-show="!item.choice && item.description && item.isExtend"
                >
                    {{ item.description }}
                </p>
                <p
                    class="item_desp"
                    v-show="item.choice && item.comboDesp && item.isExtend"
                >
                    <span>{{ item.comboDesp }}</span>
                    <span class="option">{{ item.comboSelected }}</span>
                </p>
            </div>
            <p class="order_total">
                共{{ cartQty }}件，小计：
                <span>￥{{ cartTotal }}</span>
            </p>
        </div>
        <div v-show="recommendsList.length" class="recommends">
            <h3>推荐搭配</h3>
            <div class="recommend_list fc">
                <div
                    v-if="!showAllRecommnds && recommendsList.length"
                    class="recommend_item fr ac jsb"
                    @click="selectRecommend(0)"
                >
                    <div class="fr ac">
                        <img
                            class="item_pic"
                            :src="imgBaseUrl + recommendsList[0].logo"
                            alt
                        />
                        <span class="item_name">{{
                            recommendsList[0].name
                        }}</span>
                    </div>
                    <div class="fr ac">
                        <span
                            class="ori_price"
                            v-show="
                                recommendsList[0].martetprice &&
                                recommendsList[0].martetprice >
                                    recommendsList[0].price
                            "
                            >￥{{ recommendsList[0].martetprice }}</span
                        >
                        <span class="price"
                            >￥{{ recommendsList[0].price }}</span
                        >
                        <img
                            class="select_icon"
                            :src="
                                recommendsList[0].isSelected
                                    ? selectedIcon
                                    : selectIcon
                            "
                            alt
                        />
                    </div>
                </div>
                <div
                    v-else
                    class="recommend_item fr ac jsb"
                    v-for="(item, index) in recommendsList"
                    :key="index"
                    @click="selectRecommend(index)"
                >
                    <div class="fr ac">
                        <img
                            class="item_pic"
                            :src="imgBaseUrl + item.logo"
                            alt
                        />
                        <span class="item_name">{{ item.name }}</span>
                    </div>
                    <div class="fr ac">
                        <span
                            class="ori_price"
                            v-show="
                                item.martetprice &&
                                item.martetprice > item.price
                            "
                            >￥{{ item.martetprice }}</span
                        >
                        <span class="price">￥{{ item.price }}</span>
                        <img
                            class="select_icon"
                            :src="item.isSelected ? selectedIcon : selectIcon"
                            alt
                        />
                    </div>
                </div>
                <div class="show_more center" @click="toggleRecommends">
                    <span>{{
                        showAllRecommnds ? "收起全部" : "展开全部"
                    }}</span>
                    <img
                        :src="showAllRecommnds ? collapseIcon : extendIcon"
                        alt
                    />
                </div>
            </div>
        </div>
        <div v-show="!isWaiSong" class="dine_type">
            <h3>就餐方式</h3>
            <div class="fr ac jsb">
                <span
                    @click="switchType('dineIn')"
                    :class="dineType == 'dineIn' ? 'type active' : 'type'"
                    >堂食</span
                >
                <span
                    @click="switchType('takeAway')"
                    :class="dineType == 'takeAway' ? 'type active' : 'type'"
                    >打包带走</span
                >
            </div>
        </div>
        <div class="remark_info fc">
            <div class="remark_title fr ac jsb" @click="toggleRemark">
                <h3>更多需要</h3>
                <img :src="showRemark ? collapseIcon : extendIcon" alt />
            </div>
            <div v-show="showRemark" class="remark_list fc">
                <span class="sub_title">其他自助点餐要求</span>
                <div class="list fr fw">
                    <span
                        :class="
                            item.isSelected
                                ? 'remark_item selected'
                                : 'remark_item'
                        "
                        v-for="(item, index) in remarkList"
                        :key="index"
                        @click="selectRemark(index)"
                        >{{ item.name }}</span
                    >
                </div>
            </div>
        </div>
        <p class="notice" v-if="!isWaiSong">
            温馨提示：点餐为第三方提供的代下单服务，取餐码收取可能会有延迟。当你支付后，请凭取餐码等候门店屏幕的显示即可取餐。如有疑问请联系客服。
        </p>
        <p class="notice" v-if="isWaiSong">
            温馨提示：点餐服务为第三方代下单提供，当您支付后，需要一定的配送时间配送至您的手中，请合理安排时间进行点餐，一般为45分钟以内，如遇特殊情况请联系平台客服
        </p>
        <div class="footer fr ac jsb">
            <span
                >￥{{ (cartTotal * 1 + recommendsTotal * 1).toFixed(1) }}</span
            >
            <button @click="createOrder">确认支付</button>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            disttype: this.getLocal("selectedKfcType"),
            isWaiSong: false,
            imgBaseUrl: this.$global.imgBaseUrl,
            recommendsList: [],
            selectedRecommends: [],
            recommendsTotal: 0,
            showAllRecommnds: false,
            addressList: [],
            defaultAddress: {},
            selectedAddress: this.getLocal("selectedAddress")
                ? this.getLocal("selectedAddress")
                : this.defaultAddress,
            selectedDiner: this.getLocal("selectedDiner"),
            cartArr: this.getLocal("cartArr"),
            dineType: this.getLocal("dineType")
                ? this.getLocal("dineType")
                : "dineIn",
            cartTotal: this.$route.query.cartTotal,
            cartQty: this.$route.query.cartQty,
            remarkList: [
                {
                    name: "饮料不加冰",
                    isSelected: false,
                },
            ],
            showRemark: false,
            remarkTxt: "",
            extendIcon: require("../../../static/imgs/kfc/extend.png"),
            collapseIcon: require("../../../static/imgs/kfc/collapse.png"),
            selectIcon: require("../../../static/imgs/kfc/kfc-check.png"),
            selectedIcon: require("../../../static/imgs/kfc/kfc-checked.png"),
            domainType: this.$global.domainType,
            txid: this.$global.txid,
        };
    },
    watch: {
        cartArr(val, oldVal) {
            this.getRecommendsList();
            this.showAllRecommnds = false;
            this.recommendsTotal = 0;
        },
    },
    components: {},
    activated() {
        // this.cartArr = this.getLocal("cartArr");
        this.selectedDiner = this.getLocal("selectedDiner");
        let cartArr = this.getLocal("cartArr");
        for (let i of cartArr) {
            i.isExtend = false;
        }
        this.cartArr = cartArr;
        this.disttype = this.getLocal("selectedKfcType");
        this.cartTotal = this.$route.query.cartTotal;
        this.cartQty = this.$route.query.cartQty;
        this.isWaiSong = this.getLocal("selectedKfcType") === "waisong";
        this.getAddressList();
        console.log("cartArr", this.cartArr);
    },
    created() {
        this.getRecommendsList();
    },

    methods: {
        switchType(type) {
            this.dineType = type;
        },
        toggleRemark() {
            this.showRemark = !this.showRemark;
        },
        selectRemark(idx) {
            this.remarkList[idx].isSelected = !this.remarkList[idx].isSelected;
            let remarkTxt = "";
            for (let i of this.remarkList) {
                if (i.isSelected) {
                    remarkTxt = remarkTxt + i.name + " ";
                }
            }
            this.remarkTxt = remarkTxt;
        },
        createOrder() {
            if (this.disttype == "waisong") {
                if (!this.selectedAddress.id || !this.addressList.length) {
                    Toast({
                        message: "请先填写配送地址",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                    return;
                }
            }

            let cartArr = this.cartArr,
                idTxt = "",
                selectedRecommends = this.selectedRecommends,
                recommendArr = [];
            if (selectedRecommends.length) {
                let recommendsIdArr = [],
                    cartIdArr = [];
                for (let i of selectedRecommends) {
                    recommendsIdArr.push(i.id);
                }
                for (let i of cartArr) {
                    cartIdArr.push(i.id);
                }
                for (let i in recommendsIdArr) {
                    if (cartIdArr.indexOf(recommendsIdArr[i]) >= 0) {
                        let idx = cartIdArr.indexOf(recommendsIdArr[i]);
                        cartArr[idx].qty = cartArr[idx].qty + 1;
                    } else {
                        this.$set(selectedRecommends[i], "qty", 1);
                        recommendArr.push(selectedRecommends[i]);
                    }
                }
            }
            let fullArr = cartArr.concat(recommendArr);
            for (let i of fullArr) {
                if (i.choice) {
                    idTxt += i.id;
                    for (let j of i.singleItemList) {
                        idTxt = idTxt + "," + j.id;
                    }
                    for (let k of i.mutiArr) {
                        for (let m of k[1]) {
                            if (m.isSelected) {
                                idTxt = idTxt + "," + m.id;
                            }
                        }
                    }
                } else {
                    idTxt = idTxt + i.id + "#" + i.qty;
                }
                idTxt += "@";
            }
            idTxt = idTxt.substr(0, idTxt.length - 1);
            console.log(idTxt);
            this.$post({
                method:
                    this.disttype == "waisong"
                        ? "kfc.member.waisong.order.create"
                        : "kfc.member.order.create",
                auth_code: this.getLocal("auth_code"),
                productids: idTxt,
                venueid: this.disttype == "zizhu" ? this.selectedDiner.id : "",
                memberRemark: this.remarkTxt,
                eatmodel:
                    this.dineType == "takeAway" && this.disttype == "zizhu"
                        ? "打包带走"
                        : this.disttype == "zizhu"
                        ? "店内就餐"
                        : "",
                addressid:
                    this.disttype == "waisong" ? this.selectedAddress.id : "",
                domain: this.domainType,
                txid: this.txid,
            }).then((res) => {
                if (res.success) {
                    this.setLocal("cartArr", []);
                    let appkey = this.$global.appkey;
                    if (
                        appkey == "dumovie_iOS" ||
                        appkey == "dumovie_Android"
                    ) {
                        window.location.href = "dumovie://com.dumovie/order/pay/meishi/" + res.data.tradeno;
                    } else {
                        this.$router.replace({
                            path: "/confirmOrder",
                            query: {
                                tradeno: res.data.tradeno,
                                orderType: "MS",
                                isKfc: true,
                            },
                        });
                    }
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
        },
        addAddress() {
            this.$router.push("/newAddress");
        },
        toAddressList() {
            this.$router.push("/addressList");
        },
        getAddressList() {
            this.$post({
                method: "member.drama.express.address.list",
                auth_code: this.getLocal("auth_code"),
            }).then((res) => {
                if (res.success) {
                    this.addressList = res.data.addresslist;
                    if (this.addressList && this.addressList.length > 0) {
                        this.defaultAddress = this.addressList[0];
                    }

                    for (let i of res.data.addresslist) {
                        if (i.isdefault == "Y") {
                            this.defaultAddress = i;
                            break;
                        }
                    }

                    this.selectedAddress = this.getLocal("selectedAddress")
                        ? this.getLocal("selectedAddress")
                        : this.defaultAddress;

                    console.log(this.selectedAddress);
                }
            });
        },
        toggleDetail(idx) {
            this.cartArr[idx].isExtend = this.cartArr[idx].isExtend
                ? false
                : true;
        },
        getRecommendsList() {
            this.$post({
                method: "kfc.product.dapei.list",
                disttype: this.disttype,
            }).then((res) => {
                if (res.success) {
                    this.recommendsList = res.data.productList;
                }
            });
        },
        toggleRecommends() {
            this.showAllRecommnds = !this.showAllRecommnds;
        },
        selectRecommend(idx) {
            this.$set(
                this.recommendsList[idx],
                "isSelected",
                this.recommendsList[idx].isSelected ? false : true
            );
            let selectedRecommends = [],
                recommendsTotal = 0;
            for (let i of this.recommendsList) {
                if (i.isSelected) {
                    selectedRecommends.push(i);
                    recommendsTotal += i.price;
                }
            }
            this.selectedRecommends = selectedRecommends;
            this.recommendsTotal = recommendsTotal;
        },
    },
};
</script>
<style scoped lang="scss">
.kfc_checkout_wrap {
    padding-bottom: 140px;
    .diner_info {
        width: 100%;
        padding: 30px;
        box-sizing: border-box;
        font-size: 28px;
        line-height: 40px;
        background: #fff;
        margin-bottom: 20px;
    }
    .delivery_info {
        margin-bottom: 20px;
        h3 {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 32px;
            font-weight: bold;
            background: #fff;
            border-bottom: 1px solid #dededf;
        }
        .info {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 145px;
            background: #fff;
            font-size: 28px;
            .location_icon {
                width: 66px;
                height: 66px;
                margin-right: 20px;
            }
            .receiver_info {
                margin-bottom: 8px;
                .receiver {
                    margin-right: 10px;
                }
            }
            .address {
                color: #999;
                line-height: 36px;
            }
            .add_address {
                color: #d62f35;
            }
            .right_icon {
                width: 9px;
                height: 17px;
            }
        }
    }
    .order_detail {
        margin-bottom: 20px;
        h3 {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 32px;
            font-weight: bold;
            background: #fff;
            border-bottom: 1px solid #dededf;
        }
        .order_item_wrap {
            background: #fff;
            .order_item {
                font-size: 28px;
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                height: 100px;
                line-height: 100px;
                .toggle {
                    font-size: 24px;
                    text-decoration: underline;
                    color: #999;
                    margin-left: 10px;
                }
                img {
                    width: 66px;
                    height: 66px;
                    margin-right: 20px;
                }
                .qty {
                    margin-left: 20px;
                    color: #999;
                }
            }
            .item_desp {
                width: 100%;
                padding: 0 30px 10px 30px;
                box-sizing: border-box;
                font-size: 22px;
                color: #999;
                border-bottom: 1px solid #dededf;
                line-height: 30px;
                .option {
                    color: #d62f35;
                }
            }
        }
        .order_total {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 28px;
            background: #fff;
            text-align: right;
            span {
                color: #d62f35;
            }
        }
    }
    .recommends {
        margin-bottom: 20px;
        h3 {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 32px;
            font-weight: bold;
            background: #fff;
            border-bottom: 1px solid #dededf;
        }
        .recommend_list {
            .recommend_item {
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                background: #fff;
                height: 100px;
                font-size: 28px;
                .item_pic {
                    width: 66px;
                    height: 66px;
                    margin-right: 20px;
                }
                .ori_price {
                    color: #999;
                    text-decoration: line-through;
                    margin-right: 20px;
                }
                .price {
                    font-size: 32px;
                    color: #d62f35;
                    margin-right: 30px;
                }
                .select_icon {
                    width: 42px;
                    height: 42px;
                }
            }
            .show_more {
                width: 100%;
                height: 40px;
                font-size: 20px;
                color: #999;
                background: #fff;
                img {
                    width: 18px;
                    height: 11px;
                    margin-left: 18px;
                }
            }
        }
    }
    .dine_type {
        h3 {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 80px;
            line-height: 80px;
            font-size: 32px;
            font-weight: bold;
            background: #fff;
            border-bottom: 1px solid #dededf;
        }
        div {
            width: 100%;
            padding: 30px;
            box-sizing: border-box;
            margin-bottom: 20px;
            background: #fff;
            span {
                width: 48%;
                height: 80px;
                line-height: 80px;
                font-size: 32px;
                text-align: center;
                border: 1px solid #dededf;
                border-radius: 10px;
            }
            .active {
                color: #fff;
                background: #d62f35;
            }
        }
    }
    .remark {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        height: 100px;
        line-height: 100px;
        font-size: 28px;
        background: #fff;
        h3 {
            font-size: 32px;
            font-weight: bold;
        }
        input {
            font-size: 28px;
            text-align: right;
            width: 450px;
        }
    }
    .remark_info {
        width: 100%;
        background: #fff;
        .remark_title {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 100px;
            line-height: 100px;
            font-size: 28px;
            h3 {
                font-size: 32px;
                font-weight: bold;
            }
            img {
                width: 27px;
                height: 15px;
            }
        }
        .remark_list {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            .sub_title {
                font-size: 28px;
                color: #999;
                height: 70px;
                line-height: 70px;
            }
            .list {
                width: 100%;
                .remark_item {
                    height: 50px;
                    line-height: 50px;
                    font-size: 26px;
                    padding: 0 12px;
                    border: 1px solid #999;
                    color: #999;
                    border-radius: 5px;
                    margin-bottom: 20px;
                }
                .selected {
                    color: #d62f35;
                    border: 1px solid #d62f35;
                }
            }
        }
    }
    .notice {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        font-size: 24px;
        color: #999;
        display: inline-block;
        margin-top: 20px;
        line-height: 36px;
    }
    .footer {
        width: 100%;
        height: 120px;
        background: #fff;
        position: fixed;
        bottom: 0;
        span {
            margin-left: 30px;
            font-size: 32px;
            color: #d62f35;
        }
        button {
            width: 250px;
            text-align: center;
            background: #d62f35;
            font-size: 32px;
            color: #fff;
            border-radius: 0;
            height: 120px;
            line-height: 120px;
            padding: 0 40px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/kfc/kfcCheckout.vue